// Sidebar imports
import {
  UilEstate,
  UilClipboardAlt,
  UilUsersAlt,
  UilLinkAlt,
  UilFileAlt,
  UilLocationPoint,
  UilCommentAltMessage,
} from "@iconscout/react-unicons";
import { UilUsdSquare, UilMoneyWithdrawal } from "@iconscout/react-unicons";
import Promotions from "../components/Promotions/Promotions";
import Receipts from "../components/Receipts/Receipts";
import UserProfile from "../components/UserProfile/UserProfile";
import UserOrders from "../components/UserOrders/UserOrders";
import ConnectedApps from "../components/ConnectedApps/ConnectedApps";
import SavedAddresses from "../components/SavedAddresses/SavedAddresses";
import MyQuotes from "../components/MyQuotes/MyQuotes";
import UserTickets from "../components/UserTickets/UserTickets";
import SupportCaseList from "../components/SupportCases/SupportCaseList";
import InviteFriends from "../components/Referral/InviteFriends";

// Sidebar Data
export const SidebarData = [
  {
    icon: <UilEstate />,
    heading: "My Orders",
    path: "/my_orders",
    component: UserOrders,
  },
  {
    icon: <UilClipboardAlt />,
    heading: "My Tickets",
    path: "/my_tickets",
    component: UserTickets,
  },
  {
    icon: <UilFileAlt />,
    heading: "My Quotes",
    path: "/my_quotes",
    component: MyQuotes,
  },
  {
    icon: <UilUsersAlt />,
    heading: "Profile",
    path: "/profile",
    component: UserProfile,
  },
  // Invite friends: a free first delivery for them, one for you (server-owned).
  {
    icon: <UilUsersAlt />,
    heading: "Invite Friends",
    path: "/invite_friends",
    component: InviteFriends,
  },
  {
    icon: <UilClipboardAlt />,
    heading: "Promotions",
    path: "/promotions",
    component: Promotions,
  },
  // Receipts
  {
    icon: <UilUsersAlt />,
    heading: "Receipts",
    path: "/receipts",
    component: Receipts,
  },
  // Reported issues: the SAME list component the standalone /support-cases
  // page mounts, so the account panel and the deep linkable URL cannot drift.
  {
    icon: <UilCommentAltMessage />,
    heading: "My Issues",
    path: "/support_cases",
    component: SupportCaseList,
  },
  // Connected AI Apps
  {
    icon: <UilLinkAlt />,
    heading: "Connected Apps",
    path: "/connected_apps",
    component: ConnectedApps,
  },
  // Saved delivery addresses (full CRUD; reused at checkout)
  {
    icon: <UilLocationPoint />,
    heading: "Saved Addresses",
    path: "/saved_addresses",
    component: SavedAddresses,
  },
];

// Analytics Cards Data
export const cardsData = [
  {
    title: "Sales",
    color: {
      backGround: "linear-gradient(180deg, #bb67ff 0%, #c484f3 100%)",
      boxShadow: "0px 10px 20px 0px #e0c6f5",
    },
    barValue: 70,
    value: "25,970",
    png: UilUsdSquare,
    series: [
      {
        name: "Sales",
        data: [31, 40, 28, 51, 42, 109, 100],
      },
    ],
  },
  {
    title: "Revenue",
    color: {
      backGround: "linear-gradient(180deg, #FF919D 0%, #FC929D 100%)",
      boxShadow: "0px 10px 20px 0px #FDC0C7",
    },
    barValue: 80,
    value: "14,270",
    png: UilMoneyWithdrawal,
    series: [
      {
        name: "Revenue",
        data: [10, 100, 50, 70, 80, 30, 40],
      },
    ],
  },
  {
    title: "Expenses",
    color: {
      backGround:
        "linear-gradient(rgb(248, 212, 154) -146.42%, rgb(255 202 113) -46.42%)",
      boxShadow: "0px 10px 20px 0px #F9D59B",
    },
    barValue: 60,
    value: "4,270",
    png: UilClipboardAlt,
    series: [
      {
        name: "Expenses",
        data: [10, 25, 15, 30, 12, 15, 20],
      },
    ],
  },
];
